export default __webpack_public_path__ + "static/media/bgcard.f3f0e69e.png";